import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import "./styles.css";

export const HeadInitialize = ({ onSkipClick, onContinueClick }) => {
  const { t } = useTranslation("scanModule");

  return (
    <>
      <div className="top-head-info-container">
        <h2 className="top-head-info-heading">{t("hairdresser-title")}</h2>
        <p>{t("hairdresser-description")}</p>
      </div>
      <div className="top-head-info-buttons">
        <Button
          text={t("skip")}
          onClick={() => onSkipClick()}
          alternateColor={true}
          usePrimaryColor={false}
        />
        <Button
          text={t("continue")}
          onClick={() => onContinueClick()}
          alternateColor={true}
        />
      </div>
    </>
  );
};
